import React from 'react';
import './css/PolicyPage.css';

const PolicyPage = ({ title, intro, sections }) => {
  return (
    <section className="policy-page">
      <div className="policy-hero">
        <div className="policy-hero-inner">
          <p className="policy-eyebrow">Walnut Industries</p>
          <h1>{title}</h1>
          <p className="policy-intro">{intro}</p>
        </div>
      </div>

      <div className="policy-content">
        {sections.map((section, index) => (
          <article className="policy-card" key={index}>
            <h2>{section.heading}</h2>
            {Array.isArray(section.body) ? (
              <ul>
                {section.body.map((item, itemIndex) => (
                  <li key={itemIndex}>{item}</li>
                ))}
              </ul>
            ) : (
              <p>{section.body}</p>
            )}
          </article>
        ))}
      </div>
    </section>
  );
};

export default PolicyPage;
